export const language: any ={
    cancel: "रद्द करें",
    ok: "ठीक",
}